import { PRIVATE_URIS } from '../constants/privateURIs.constants';

/**
 * Builds the per-post version-history route from its PRIVATE_URIS template,
 * keeping the '/post/:postId/history' shape in a single source of truth.
 */
export function postHistoryPath(postId: string): string {
  return PRIVATE_URIS.POST_HISTORY.replace(':postId', postId);
}
